// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"InfoRow_infoRow__3DVS3","infoRowTitle":"InfoRow_infoRowTitle__3x9Mi"};